import {
  AlertSpg,
  BlockText,
  GridContainer,
  GridItem,
  isNotEmpty,
  selectThunkRecordById,
  ViewSection,
} from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import useUserBirthPlace from "../../../../../../hooks/portal/view/user/useUserBirthPlace";
import { useEffect, useState } from "react";
import * as React from "react";
import { useTranslation } from "react-i18next";

const ContactAddressViewSection = ({ record }) => {
  const { t } = useTranslation();

  const [isEmptyContactAddress, setIsEmptyContactAddress] = useState(false);
  const countriesData = useAppSelector((state) => {
    return state.AppData.countriesData.data;
  });

  const { birthPlace } = useUserBirthPlace({
    country: record.contactAddress?.country,
    settlement: record.contactAddress?.settlement,
    city: record.contactAddress?.city,
  });

  useEffect(() => {
    const contactAddressValues = [
      record.contactAddress?.country?.id,
      birthPlace,
      record.contactAddress?.postCode,
      record.contactAddress?.address,
      record.contactAddress?.postBox,
      record.contactAddress?.phone,
      record.contactAddress?.email,
      record.contactAddress?.fax,
    ];

    const isEmpty =
      contactAddressValues.filter(function (el) {
        return isNotEmpty(el);
      }).length === 0;
    setIsEmptyContactAddress(isEmpty);
    // eslint-disable-next-line
  }, []);

  return (
    <ViewSection label={"t.contactAddress.details.default"}>
      {!isEmptyContactAddress && (
        <GridContainer spacing={3} mt={0}>
          <BlockText
            withGrid
            label={"l.address.country"}
            text={selectThunkRecordById(record.contactAddress?.country?.id, countriesData)?.name}
          />
          <BlockText withGrid label={"l.address.cityName"} text={birthPlace} />
          <BlockText withGrid label={"l.address.postCode"} text={record.contactAddress?.postCode} />
          <BlockText withGrid label={"l.address.address"} text={record.contactAddress?.address} />
          <BlockText withGrid label={"l.address.postBox"} text={record.contactAddress?.postBox} />
          <BlockText withGrid label={"l.address.phone"} text={record.contactAddress?.phone} />
          <BlockText withGrid label={"l.address.email"} text={record.contactAddress?.email} />
          <BlockText withGrid label={"l.address.fax"} text={record.contactAddress?.fax} />
        </GridContainer>
      )}
      {isEmptyContactAddress && (
        <GridContainer spacing={2} mt={0}>
          <GridItem sm={12} md={12} lg={12} paddingLeft={"10px"}>
            <AlertSpg severity={"info"}>{t("m.empty.contactAddress.default")}</AlertSpg>
          </GridItem>
        </GridContainer>
      )}
    </ViewSection>
  );
};
export default ContactAddressViewSection;
